export default "__VITE_ASSET__12jMiMNr__"